export const biochemistryData = {
  departmentName: "Department of Biochemistry",
  bannerImage: "/biochemistry/banner.jpg",
  
  about: {
    title: "About the Department",
    content: `The Department of Biochemistry at Rayalaseema University is dedicated to understanding the chemical 
    processes within and relating to living organisms. Our programs cover molecular biology, enzymology, metabolism, 
    immunology, and clinical biochemistry. We emphasize both fundamental research and applied aspects of biochemistry, 
    preparing students for careers in healthcare, pharmaceuticals, research, and diagnostics.`,
    highlights: [
      "Well-equipped biochemistry and molecular biology laboratories",
      "Research focus on enzymology and metabolic disorders",
      "Clinical biochemistry and diagnostic techniques",
      "Collaborations with medical institutions and research centers"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/biochemistry/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {
    name: "Prof. Sridhar Reddy",
    designation: "Professor & Head",
    photo: "/biochemistry/sridhar-reddy.jpg",
    email: "sridhar.reddy@ruk.ac.in",
    mobile: "+91 98765 43268",
    qualification: "M.Sc., Ph.D.",
    specialization: "Enzymology, Metabolic Biochemistry",
    message: `Welcome to the Department of Biochemistry. We are committed to advancing knowledge in the molecular 
    basis of life and its applications in medicine and biotechnology. Our department provides excellent opportunities 
    for students to engage in cutting-edge research and develop expertise in biochemical sciences.`,
    profileLink: "/biochemistry/SRIDHAR-REDDY.pdf"
  },

  bos: {
    title: "Board of Studies",
    members: [
      {
        name: "Prof. Sridhar Reddy",
        designation: "Chairman",
        affiliation: "Rayalaseema University"
      },
      {
        name: "Dr. Pushpa Latha",
        designation: "Member",
        affiliation: "Rayalaseema University"
      },
      {
        name: "Dr. Harish Kumar",
        designation: "Member",
        affiliation: "Rayalaseema University"
      },
      {
        name: "Prof. External Expert",
        designation: "External Member",
        affiliation: "Medical Research Institute"
      }
    ]
  },

  faculty: [
    {
      name: "Prof. Sridhar Reddy",
      designation: "Professor & Head",
      email: "sridhar.reddy@ruk.ac.in",
      mobile: "+91 98765 43268",
      photo: "/biochemistry/sridhar-reddy.jpg",
      qualification: "M.Sc., Ph.D.",
      specialization: "Enzymology, Metabolic Biochemistry",
      profileLink: "/biochemistry/SRIDHAR-REDDY.pdf"
    },
    {
      name: "Dr. Pushpa Latha",
      designation: "Associate Professor",
      email: "pushpa.latha@ruk.ac.in",
      mobile: "+91 98765 43269",
      photo: "/biochemistry/pushpa-latha.jpg",
      qualification: "M.Sc., Ph.D.",
      specialization: "Clinical Biochemistry, Immunology",
      profileLink: "/biochemistry/PUSHPA-LATHA.pdf"
    },
    {
      name: "Dr. Harish Kumar",
      designation: "Assistant Professor",
      email: "harish.kumar@ruk.ac.in",
      mobile: "+91 98765 43270",
      photo: "/biochemistry/harish-kumar.jpg",
      qualification: "M.Sc., Ph.D.",
      specialization: "Molecular Biology, Protein Chemistry",
      profileLink: "/biochemistry/HARISH-KUMAR.pdf"
    }
  ],

  courses: {
    undergraduate: [
      {
        name: "B.Sc. Biochemistry",
        duration: "3 Years",
        eligibility: "10+2 with Biology and Chemistry",
        intake: "40 seats"
      }
    ],
    postgraduate: [
      {
        name: "M.Sc. Biochemistry",
        duration: "2 Years",
        eligibility: "B.Sc. with Biochemistry/Chemistry/Biology",
        intake: "30 seats"
      }
    ],
    research: [
      {
        name: "Ph.D. in Biochemistry",
        duration: "Minimum 3 Years",
        eligibility: "M.Sc. Biochemistry with qualifying exam",
        areas: "Enzymology, Molecular Biology, Clinical Biochemistry, Immunology, Metabolic Disorders"
      }
    ]
  },

  events: [
    {
      title: "Biochemistry Symposium",
      date: "February 2025",
      description: "Annual symposium featuring research presentations and expert lectures on biochemical sciences",
      type: "Symposium"
    },
    {
      title: "Clinical Biochemistry Workshop",
      date: "January 2025",
      description: "Workshop on clinical diagnostic techniques and interpretation of biochemical tests",
      type: "Workshop"
    },
    {
      title: "Research Methodology Course",
      date: "March 2025",
      description: "Short-term course on research techniques in biochemistry and molecular biology",
      type: "Training"
    },
    {
      title: "Guest Lecture on Drug Discovery",
      date: "April 2025",
      description: "Special lecture on the role of biochemistry in pharmaceutical drug discovery",
      type: "Seminar"
    }
  ]
};
